<template>
  <div class="container" style="overflow-y:auto">
    <div class="header-actions">
      <Input v-model="searchQuery" placeholder="搜索课程名称" clearable style="width: 300px" />
      <Button type="primary" @click="handleSearch" style="margin-left: 10px">搜索</Button>
      <Button type="success" @click="handleAddCourse" style="margin-left: 10px">新建课程</Button>

      <div class="filter-group">
        <RadioGroup v-model="currentState" type="button" @on-change="handleStateChange">
          <Radio label="all">全部</Radio>
          <Radio v-for="state in stateOptions" :key="state.value" :label="state.value">
            {{ state.label }}
          </Radio>
        </RadioGroup>
        </div>
    </div>

    <div class="table-wrapper">
      <BaseTable
        :columns="columns"
        :data="items"
        :loading="loading"
        :count="total"
        paged
        :page="page"
        :pageSize="pageSize"
        border
        @event="handleTableEvent"
      ></BaseTable>
    </div>

    <!-- Course Form Modal -->
    <Modal
      v-model="courseModalVisible"
      :title="courseModalTitle"
      @on-ok="handleCourseSubmit"
      :loading="confirmLoading"
      width="600"
    >
      <Form ref="formRef" :model="formData" :rules="rules">
        <BaseSegment title="项目信息">
          <div class="form-row">
            <FormItem label="所属项目" prop="project_id" required class="form-item-large">

              <Select v-model="formData.project_id" filterable  transfer placeholder="请选择所属项目" style="width: 100%">
                <Option v-for="project in projects" :value="project.id" :key="project.id">
                  <span style="padding:2px 5px;background:#f0f0f0;border-radius:3px;color:#666;">{{project.created_at?moment(project.created_at).format('YYYY-MM-DD'):'-'}}</span> {{ project.name }}</Option>
              </Select>
              <div class="project-create-tip">
                <a @click="goToCreateProject">未创建项目？前往创建</a>
              </div>
            </FormItem>
          </div>
        </BaseSegment>

        <BaseSegment title="课程基本信息">
          <div class="form-row">
            <FormItem label="课程名称" prop="name" required class="form-item-large">
              <Input v-model="formData.name" placeholder="请输入课程名称" maxlength="32" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="讲师" prop="charger"  class="form-item">
              <BaseUserSelect v-model="formData.charger" placeholder="请选择讲师" />
            </FormItem>
            <FormItem label="状态" prop="state" class="form-item">
              <Select v-model="formData.state" style="width: 100%">
                <Option v-for="state in stateOptions" :key="state.value" :value="state.value">{{ state.label }}</Option>
              </Select>
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="开始时间" prop="started_at" class="form-item">
              <DatePicker v-model="formData.started_at" type="datetime" placeholder="选择开始时间" style="width: 100%" />
            </FormItem>
            <FormItem label="时长(小时)" prop="duration" class="form-item">
              <InputNumber v-model="formData.duration" :min="0" :step="0.5" placeholder="请输入课程时长" style="width: 100%" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="上课地点" prop="address" class="form-item-large">
              <Input v-model="formData.address" placeholder="请输入上课地点" maxlength="255" />
            </FormItem>
          </div>
        </BaseSegment>

        <BaseSegment title="课程内容">
          <div class="form-row">
            <FormItem label="描述" prop="desc" class="form-item-large">
              <Input v-model="formData.desc" type="textarea" :rows="4" placeholder="请输入课程描述" maxlength="255" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="视频文件" prop="video_url" class="form-item">
              <BaseFileUpload v-model="formData.video_url" accept="video/*" />
            </FormItem>
            <FormItem label="封面图片" prop="avatar" class="form-item">
              <BaseFileUpload v-model="formData.avatar" accept="image/*" />
            </FormItem>
          </div>
        </BaseSegment>
      </Form>
    </Modal>

    <!-- Video Player Modal -->
    <Modal
      v-model="videoModalVisible"
      title="课程视频"
      footer-hide
      width="800"
      :mask-closable="true"
      :styles="{top: '20px'}"
    >
      <div v-if="currentVideo" class="video-player-container">
        <div class="video-title">{{ currentVideo.name }}</div>
        <video
          ref="videoPlayer"
          class="video-player"
          controls
          autoplay
          :src="currentVideo.video_url"
        ></video>
        <div class="video-info">
          <div class="video-info-item">
            <span class="label">项目：</span>
            <span v-if="currentVideo.project">{{ currentVideo.project.name }}</span>
          </div>
          <div class="video-info-item">
            <span class="label">讲师：</span>
            <BaseNameBoard :uid="currentVideo.charger" />
          </div>
          <div class="video-info-item">
            <span class="label">开始时间：</span>
            <span>{{ formatDateTime(currentVideo.started_at) }}</span>
          </div>
          <div class="video-info-item" v-if="currentVideo.desc">
            <span class="label">描述：</span>
            <div class="video-desc">{{ currentVideo.desc }}</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      items: [],
      searchQuery: '',
      currentState: 'all',
      projects: [],
      total: 0,
      page: 1,
      pageSize: 20,

      // 课程表单
      courseModalVisible: false,
      courseModalTitle: '添加课程',
      confirmLoading: false,
      currentId: null,
      formData: this.getInitialFormData(),

      // 视频播放
      videoModalVisible: false,
      currentVideo: null,

      stateOptions: [
        {label: '未开始', value: '0'},
        {label: '进行中', value: '1'},
        {label: '已结束', value: '2'},
      ],

      // 表格列定义
      columns: [
        {type: 'index', width: 60, title: '序号'},
        {
          title: '课程',
          key: 'name',
          minWidth: 240,
          render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
              },
            }, [
              h('div', {
                style: {
                  width: '60px',
                  height: '40px',
                  borderRadius: '4px',
                  overflow: 'hidden',
                  margin: '5px',
                  marginRight: '10px',
                  background: '#f0f0f0',
                  flexShrink: 0,
                },
              }, [
                params.row.avatar ? h('img', {
                  attrs: {
                    src: params.row.avatar,
                    alt: params.row.name,
                  },
                  style: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  },
                }) : h('div', {
                  style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',

                    color: '#999',
                  },
                }, params.row.name.substring(0, 1)),
              ]),
              h('div', [
                h('div', {
                  style: {
                    fontWeight: 'bold',
                  },
                }, params.row.name),

              ]),
            ]);
          },
        },
        {
          title: '所属项目',
          key: 'project_name',
          width: 240,
          render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                padding: '0 10px',
                textAlign: 'left',
                justifyContent: 'flex-start',
              },
            },
              params.row.project ? params.row.project.name : '-',
            );
          },
        },
        {
          title: '讲师',
          key: 'charger',
          width: 120,
          type: 'user',
        },
        {
          title: '上课地点',
          key: 'address',
          width: 150,
          render: (h, params) => {
            return h('span', params.row.address || '-');
          },
        },
        {
          title: '开始时间',
          key: 'started_at',
          width: 150,
          render: (h, params) => {
            return h('span', this.formatDateTime(params.row.started_at));
          },
        },
        {
          title: '时长',
          key: 'duration',
          width: 100,
          render: (h, params) => {
            return h('span', params.row.duration ? `${params.row.duration}小时` : '-');
          },
        },
        {
          title: '状态',
          key: 'state',
          width: 100,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.getStateColor(params.row.state),
              },
            }, this.getStateLabel(params.row.state));
          },
        },
        {
          title: '视频',
          key: 'video',
          width: 80,
          render: (h, params) => {
            if (!params.row.video_url) return h('span', '-');

            return h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                icon: 'ios-play',
              },
              on: {
                click: () => {
                  this.handleViewVideo(params.row);
                },
              },
            }, '观看');
          },
        },{
          title: '分享',
          key: 'video',
          width: 80,
          render: (h, params) => {
            if (!params.row.video_url) return h('span', '-');

            return h('Button', {
              props: {
                type: 'success',
                size: 'small',
                icon: 'ios-share',
              },
              on: {
                click: () => {
                  this.shareVideo(params.row);
                },
              },
            }, '分享');
          },
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.handleEditCourse(params.row);
                  },
                },
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.handleDeleteCourse(params.row);
                  },
                },
              }, '删除'),
            ]);
          },
        },
      ],

      rules: {
        project_id: [{required: true, message: '请选择所属项目', trigger: 'change'}],
        name: [{required: true, message: '请输入课程名称', trigger: 'blur'}],
      },
    };
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.fetchCourses();
      this.fetchProjects();
    })
  
  },
  methods: {
    shareVideo(value){
     
    // 将视频地址复制到剪切板 video_url
    if (value && value.video_url) {
      let baseUrl = location.origin; // 获取当前域名地址和协议
      let video_url = baseUrl + '/tools/video?id=' + value.id;
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(video_url)
          .then(() => {
            this.Success('已复制视频地址!');
          })
          .catch(() => {
            this.Error('复制失败，请手动复制');
          });
      } else {
        // 兼容部分旧浏览器
        const input = document.createElement('input');
        input.value = video_url;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy');
          this.Success('已复制视频地址!');
        } catch (e) {
          this.Error('复制失败，请手动复制');
        }
        document.body.removeChild(input);
      }
    } else {
      this.Error('此视频未上传文件，复制失败');
    }
    },
    getInitialFormData() {
      const now = new Date();

      return {
        name: '',
        charger: '',
        desc: '',
        address: '',
        started_at: now,
        duration: 1,
        video_url: '',
        avatar: '',
        state: '0',
        project_id: '',
      };
    },
    async fetchCourses() {
      this.loading = true;
      try {
        const params = {
          q: 'page',
          related: 'project',
          order: 'created_at',
          desc: 1,
          page: this.page,
          pagesize: this.pageSize,
        };

        if (this.searchQuery) {
          params.search = this.searchQuery;
        }

        if (this.currentState !== 'all') {
          params.state = this.currentState;
        }

        const response = await this.$api.get('/study/classes', {params});
        const items = response.data.data.list || [];
        items.forEach((item) => {
          item.name = item.name || '未命名';
          item.project = item.project || {};
          item.project_name = item?.project?.name || '-';
          item.charger = item.charger || item.project?.charger;
          item.avatar = item.avatar || item.project?.avatar;
        });
        this.items = items;
        this.total = response.data.data.count || 0;
      } catch (error) {
        this.$Message.error('获取课程列表失败');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchProjects() {
      try {
        const response = await this.$api.get('/study/projects');
        let projects = response.data.data || [];
        projects.sort((a,b)=>{
          return moment(b.created_at).diff(moment(a.created_at));
        });
        this.projects = projects;
      } catch (error) {
        this.$Message.error('获取项目列表失败');
        console.error(error);
      }
    },
    handleTableEvent(e) {
      const {type, data} = e;
      switch (type) {
        case 'page-change':
          this.page = data;
          this.fetchCourses();
          break;
        case 'page-size-change':
          this.pageSize = data;
          this.page = 1;
          this.fetchCourses();
          break;
      }
    },
    handleSearch() {
      this.page = 1;
      this.fetchCourses();
    },
    handleStateChange() {
      this.page = 1;
      this.fetchCourses();
    },
    handleAddCourse() {
      this.courseModalTitle = '添加课程';
      this.formData = this.getInitialFormData();
      this.currentId = null;
      this.courseModalVisible = true;
    },
    handleEditCourse(course) {
      this.courseModalTitle = '编辑课程';
      this.currentId = course.id;

      // Clone the course data
      this.formData = {...course};

      // Convert string dates to Date objects
      if (this.formData.started_at) {
        this.formData.started_at = new Date(this.formData.started_at);
      }

      this.courseModalVisible = true;
    },
    handleDeleteCourse(course) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除课程 "${course.name}" 吗？此操作不可恢复。`,
        onOk: async () => {
          try {
            await this.$api.delete(`/study/classes/${course.id}`);
            this.$Message.success('删除成功');
            this.fetchCourses();
          } catch (error) {
            this.$Message.error('删除失败');
            console.error(error);
          }
        },
      });
    },
    handleViewVideo(course) {
      if (!course.video_url) {
        this.$Message.info('该课程没有视频');
        return;
      }

      this.currentVideo = course;
      this.videoModalVisible = true;
    },
    async handleCourseSubmit() {
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        // Prepare data
        const data = {...this.formData};

        // Format date
        if (data.started_at instanceof Date) {
          // Format as ISO string
          data.started_at = data.started_at.toISOString();
        }

        // The video_url and avatar will be handled by the BaseFileUpload component

        if (this.currentId) {
          // Update
          await this.$api.patch(`/study/classes/${this.currentId}`, data);
          this.$Message.success('更新成功');
        } else {
          // Create
          await this.$api.post('/study/classes', data);
          this.$Message.success('添加成功');
        }

        this.courseModalVisible = false;
        this.fetchCourses();
      } catch (error) {
        this.$Message.error(error.message || '提交失败');
        console.error(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    getStateColor(state) {
      const stateMap = {
        0: 'blue',
        1: 'green',
        2: 'default',
      };
      return stateMap[state] || 'default';
    },
    getStateLabel(state) {
      const stateMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束',
      };
      return stateMap[state] || state || '未知';
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    formatDateTime(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return `${this.formatDate(dateString)} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    goToCreateProject() {
      this.$router.push('/core/training-admin/projects');
      this.courseModalVisible = false;
    },
  },
};
</script>

<style lang="less">

.header-actions {
  margin-bottom: 20px;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.filter-group {
  margin-left: auto;
}

.table-wrapper {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
}

.video-player-container {
  .video-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 12px;
  }

  .video-player {
    width: 100%;
    max-height: 450px;
    background: #000;
  }

  .video-info {
    margin-top: 16px;

    .video-info-item {
      margin-bottom: 10px;
      display: flex;

      .label {
        width: 80px;
        color: #666;
        flex-shrink: 0;
      }

      .video-desc {
        line-height: 1.6;
      }
    }
  }
}

.form-row {
  display: flex;
  margin-bottom: 12px;

  .form-item {
    flex: 1;
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }

  .form-item-large {
    flex: 1;
    width: 100%;
  }
}

.project-create-tip {
  margin-top: 4px;
  text-align: right;
  font-size: 12px;

  a {
    color: #2d8cf0;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
